import { useEffect, useState } from "react";
import api from "../api";
import "./sedi.css";
import { useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";

const AddSedi = () => {
  const [loading, setLoading] = useState(false);
  const [indirizzoSede, setIndirizzoSede] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  const isValid = () => {
    if (indirizzoSede.trim() === "") {
      setError("Il campo Indirizzo della Sede non può essere vuoto!");
      return false;
    }
    setError("");
    return true;
  };

  const addSede = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      const response = await api.post("/sedi", {
        indirizzoSede: indirizzoSede.trim(),
      });

      if (response.status === 200 || response.data?.status === 200) {
        setIndirizzoSede("");
        toast.success("Sede aggiunta con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        navigate("/sedi");
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per aggiungere una sede!");

      navigate("/login");
      localStorage.clear();
    } else {
      setIsAuthorized(true);
    }
  }, [navigate]);

  if (!isAuthorized) return null;

  const getMapAddress = (fullAddress) => {
    if (!fullAddress) return "";
    return fullAddress.replace(/\s*\d{5}\s*/, " ");
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Aggiungi Sede</div>
      </div>

      <div className="page-content add-sedi-container">
        <div className="add-sedi-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-plus-circle"></i>
              Nuova Sede
            </div>
          </div>

          <div className="card-content">
            <div className="form-field">
              <label className="field-label">
                <i className="fa-solid fa-map-marker-alt"></i>
                Indirizzo Sede
              </label>
              <div className="field-input">
                <input
                  type="text"
                  id="indirizzoSede"
                  value={indirizzoSede}
                  onChange={(e) => {
                    setIndirizzoSede(e.target.value);
                    if (error) setError("");
                  }}
                  placeholder="Inserisci l'indirizzo della sede"
                  className={error ? "error-input" : ""}
                />
                {error && <div className="error-message">{error}</div>}
              </div>
            </div>

            <div className="action-buttons">
              <button className="cancel-btn" onClick={() => navigate("/sedi")}>
                <i className="fa-solid fa-times"></i>
                Annulla
              </button>
              <button className="save-btn" onClick={addSede}>
                <i className="fa-solid fa-plus"></i>
                Aggiungi Sede
              </button>
            </div>
          </div>
        </div>

        {indirizzoSede && (
          <div className="map-card">
            <div className="card-header">
              <div className="card-title">
                <i className="fa-solid fa-map"></i>
                Anteprima Mappa
              </div>
            </div>
            <div className="map-container">
              <iframe
                title="Map"
                width="100%"
                height="400"
                style={{ border: 0 }}
                src={`https://www.google.com/maps?q=${encodeURIComponent(
                  getMapAddress(indirizzoSede)
                )}&output=embed`}
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddSedi;
